import { HTTPError } from "ky";

interface IAjaxError extends Error {
  message: string;
  status: number;
}

export class AjaxError<
  Response extends HTTPError["response"] = HTTPError["response"],
  Request extends HTTPError["request"] = HTTPError["request"]
> extends HTTPError implements IAjaxError {
  message: string;
  status: number;
  name: string;

  constructor(
    status: number,
    response: Response,
    request: Request,
    options: HTTPError["options"],
    message?: string
  ) {
    super(response, request, options);
    this.status = status;

    // Controlla se la risposta ha un campo 'error' e usalo come messaggio di errore
    if (response && response.body) {
      const errorResponse = response.body as { error?: string };
      this.message = errorResponse.error || message || "Unknown error occurred";
    } else {
      this.message = message ?? "Unknown error occurred";
    }

    this.name = "AjaxError";
  }
}
